// extracted by mini-css-extract-plugin
export var alignRight = "v3-block-to-pdf-module--alignRight--bcb2c";
export var arrowsContainer = "v3-block-to-pdf-module--arrowsContainer--e6f12";
export var backgroundSvg = "v3-block-to-pdf-module--backgroundSvg--50466";
export var card = "v3-block-to-pdf-module--card--f5296";
export var cardContainer = "v3-block-to-pdf-module--cardContainer--f57cb";
export var container = "v3-block-to-pdf-module--container--ffc57";
export var emptyLeftPart = "v3-block-to-pdf-module--emptyLeftPart--2ea39";
export var openLink = "v3-block-to-pdf-module--openLink--83191";
export var title = "v3-block-to-pdf-module--title--27492";